import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploadMedia } from '../actions/mediaActions';
import { useEffect, useState } from 'react';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { Button, Form } from 'react-bootstrap';
import FormContainer from '../components/FormContainer';
import { Link } from 'react-router-dom';
import { VIDEO_FILE_UPLOAD_RESET } from '../constants/videoConstants';
import {listTags} from "../actions/tagActions";
import {TAG_LIST_RESET} from "../constants/tagConstants";
import {logout} from "../actions/userActions";
import ThreeColumnRow from "../components/ThreeColumnRow";
import {listCampaigns} from "../actions/campaignActions";
import {MultiSelect} from "../components/MultiSelect";
import CreatableSelect from "react-select/creatable";

const VideoRegisterScreen = ({ history, language, t }) => {
    const dispatch = useDispatch();

    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const video = useSelector((state) => state.videoCreate);
    const { loading, message, error } = video;
    const [myFile, setMyFile] = useState(null);
    const [fileName, setFileName] = useState();
    const [videoName, setVideoName] = useState('');
    const [videoHeight, setVideoHeight] = useState(0);
    const [duration, setDuration] = useState('');
    const [videoWidth, setVideWidth] = useState(0);
    const [videoNameError,setVideoNameError] = useState('');
    const [description, setDescription] = useState('');
    const [tags, setTags] = useState([]);
    const [suggestions, setSuggestions] = useState([]);

    const tagList = useSelector(state => state.tagList);
    const {loading: tagsLoading, error: tagsError, tags: userTags, success: userTagSuccess} = tagList;

    const [videoCampaignOptions, setVideoCampaignOptions] = useState([]);
    const [selectedVideoCampaigns, setSelectedVideoCampaigns] = useState([]);
    const videoCampaignsList = useSelector((state) => state.videoCampaignList);
    const {loading: videoCampaignsLoading, videoCampaignList, error: videoCampaignsError, success: videoCampaignListSuccess} = videoCampaignsList;

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(() => {
        if (!userTagSuccess) {
            dispatch(listTags());
        } else {
            setSuggestions(() =>
                userTags.map((tgs) => {
                    tgs.label = tgs.name;
                    tgs.value = tgs._id;
                    return tgs;
                })
            );
        }
    }, [userTagSuccess, dispatch]);



    useEffect(() => {
        if (message) {
            dispatch({ type: VIDEO_FILE_UPLOAD_RESET });
            history.push('/videos');
        }
    }, [dispatch, message, history]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if(videoNameError !== ''){
            return;
        }
        const formData = new FormData();
        //console.log(myFile);
        formData.append('name', videoName);
        formData.append('description', description);
        formData.append('tags', JSON.stringify(tags));
        formData.append('file', myFile);
        formData.append('width', videoWidth.toString());
        formData.append('height', videoHeight.toString());
        formData.append('duration', duration.toString());
        formData.append('orientation', videoWidth < videoHeight ? 'portrait' : videoWidth === videoHeight ? 'square' : 'landscape');

        if(selectedVideoCampaigns) {
            const properVideoCampaigns = selectedVideoCampaigns.map(element => {
                let {label, value, ...rest} = element;
                return rest;
            });

            formData.append('videoCampaigns', JSON.stringify(properVideoCampaigns));
        }

        dispatch(uploadMedia('videos', formData));
        dispatch({type: TAG_LIST_RESET});
    };

    const onFileChange = (event) => {
        //console.log(event.target.files);
        if (event.target.files.length > 0) {
            setMyFile(event.target.files[0]);
            setFileName(event.target.files[0].name);

            const url = URL.createObjectURL(event.target.files[0]);
            const $video = document.createElement("video");
            $video.src = url;
            $video.addEventListener("loadedmetadata", function () {
                setVideWidth(this.videoWidth);
                setVideoHeight(this.videoHeight);
                setDuration(this.duration.toFixed(1));
            });
        }
    };

    useEffect(()=>{
        if(!videoCampaignListSuccess){
            dispatch(listCampaigns());
        }
        if(videoCampaignList){
            //console.log(campaignList);
            const moddedList = videoCampaignList.map(element => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            //console.log(campaignList);
            setVideoCampaignOptions(moddedList);
        }
    },[dispatch, videoCampaignList, videoCampaignListSuccess]);

    const onSelectedCampaignsChange = (videoCampaignsFromSelect) => {
        setSelectedVideoCampaigns(videoCampaignsFromSelect);
    }

    return (
        <>
            <ThreeColumnRow firstColumn={<Link to='/videos' className='btn btn-info m-0 p-2'>
                {t('button_back')}
            </Link>} secondColumn={t('video_new_video')}/>

            <FormContainer>
                <Form onSubmit={handleSubmit} autoComplete='off'>
                    <Form.Group controlId='videoName'>
                        <Form.Label>{t('video_name')}</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder={t('video_name')}
                            required
                            value={videoName}
                            onChange={(event) => {
                                if(event.target.value.includes(',')){
                                    setVideoNameError(t('video_name_error'));
                                }
                                else {
                                    setVideoNameError('');
                                }
                                setVideoName(event.target.value);
                            }}
                            isInvalid={videoName.includes(',')}
                        />
                        <Form.Control.Feedback type='invalid'>{videoNameError}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId='videoFile'>
                        <Form.Label>{t('video_file')}</Form.Label>
                        <Form.File
                            label={fileName ?? t('file_select_description')}
                            accept='.mp4'
                            data-browse={t('button_select')}
                            required
                            onChange={onFileChange}
                            custom
                        />
                    </Form.Group>

                    <Form.Group controlId='videoDescription'>
                        <Form.Label>{t('video_description')}</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder={t('video_description')}
                            required
                            value={description}
                            onChange={(event) => {
                                setDescription(event.target.value);
                            }}
                        />
                    </Form.Group>

                    <Form.Group controlId='videoCampaigns'>
                        <Form.Label>{t('video_campaigns')}</Form.Label>
                        <MultiSelect
                            options={videoCampaignOptions}
                            value={selectedVideoCampaigns}
                            onChange={onSelectedCampaignsChange}
                            placeholder={t('video_campaign_select_video_campaign_description')}
                        />
                    </Form.Group>

                    {tagsLoading ? (
                        <Loader/>
                    ) : (
                        <Form.Group controlId='tags'>
                            <Form.Label>{t('video_tags')}</Form.Label>
                            <CreatableSelect
                                isMulti
                                isSearchable
                                isClearable
                                formatCreateLabel= {(inputValue) => `${t('create_tag')}: "${inputValue}"`}
                                onChange={(newTag) => {
                                    const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                    if(temporaryTag !== null && temporaryTag !== undefined){
                                        newTag = temporaryTag;
                                    }
                                    //console.log(newTag);
                                    setTags(newTag);
                                }}
                                onCreateOption={(newTag) => {
                                    const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                    if(temporaryTag !== null && temporaryTag !== undefined){
                                        newTag = temporaryTag;
                                    }
                                    else {
                                        newTag = {
                                            id: undefined,
                                            label: newTag,
                                            value: newTag,
                                            name: newTag
                                        }
                                    }
                                    //console.log(newTag);
                                    setTags([...tags, newTag]);
                                }}
                                options={suggestions}
                                value={tags}
                                placeholder={t('video_tags_description')}
                                className='react-select-container'
                                classNamePrefix='react-select'
                            />
                            {/*<ReactTags
                                allowNew={true}
                                placeholderText={t('video_tags_description')}
                                allowBackspace={false}
                                onDelete={(idx) => {
                                    const newTags = tags.slice(0);
                                    newTags.splice(idx, 1);
                                    setTags(newTags);
                                }}
                                onAddition={(newTag) => {
                                    setTags([...tags, newTag]);
                                }}
                                suggestions={suggestions}
                                tags={tags}
                            />*/}
                        </Form.Group>)}

                    <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                        {error ? (
                            <Message variant='danger'>{error}</Message>
                        ) : null}
                    </div>

                    {loading ? (
                        <Loader />
                    ) : (
                        <Button
                            type='submit'
                            variant='success'
                            className='d-block mx-auto mt-4'
                        >
                            {t('button_save')}
                        </Button>
                    )}
                </Form>
            </FormContainer>
        </>
    );
};

export default VideoRegisterScreen;
